export interface Banner {
  uri: string;
  link?: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  videoUrl?: string;

  isTeamsApp?: boolean;
  isSellersApp?: boolean;
  isWebApp?: boolean;
}

export enum BannerType {
  LOGIN = "login",
  INITIAL_PAGE = "initialPage",
  DASHBOARD_CARD = "dashboardCard",
  DASHBOARD_MODAL = "dashboardModal",
  INVITE = "invite",
}

export enum BannerOrigin {
  SELLERS = "SELLERS",
  TEAMS = "TEAMS",
  WEB = "WEB",
}
